// extracted by mini-css-extract-plugin
export default {"videoPage":"VideoPage_videoPage__mSy+D","videoPlayer":"VideoPage_videoPlayer__bL63C","listComment":"VideoPage_listComment__vL7HG"};